import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { User_id } from '../../types'

export const hipUserDetail = async (payload: User_id) => {
  const response = await axios.get(`${getAPIService}/users/${payload}`)
  return response.data
}
